"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

import { captureGrowthEvent, consumeSignupMethod } from "@/lib/analytics";
import { useSession } from "@/lib/auth-client";

export function SignupCompletionTracker() {
  const { data: session } = useSession();

  useEffect(() => {
    const user = session?.user;
    if (!user || user.isAnonymous) return;

    posthog.identify(user.id, { email: user.email });
    const signupMethod = consumeSignupMethod();
    if (signupMethod) {
      captureGrowthEvent("signup_succeeded", { method: signupMethod });
      captureGrowthEvent("onboarding_step_completed", {
        step: "create_account",
        method: signupMethod,
      });
    }
  }, [session?.user]);

  return null;
}
